var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApprovedSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.998,
    height: 29.998,
    viewBox: "0 0 29.998 29.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "approved-signal-svgrepo-com",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14690",
    "data-name": "Path 14690",
    d: "M27.988,7.5l-3.481-2.01L22.5,2.012H18.479L15,0l-3.481,2.01H7.5L5.49,5.492,2.01,7.5V11.52L0,15l2.01,3.481V22.5L5.49,24.51,7.5,27.991h4.019L15,30l3.481-2.01H22.5l2.01-3.481,3.481-2.01V18.481L30,15l-2.01-3.481V7.5ZM13.645,21.14a1.46,1.46,0,0,1-2.03,0L7.229,16.753a1.408,1.408,0,0,1,0-1.99L8.39,13.6a1.408,1.408,0,0,1,1.99,0l2.25,2.25,6.987-6.987a1.408,1.408,0,0,1,1.99,0l1.161,1.161a1.408,1.408,0,0,1,0,1.99Z",
    fill: "#5c8e00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApprovedSignal);
export default __webpack_public_path__ + "static/media/icon-approved-signal.054b9b7f34d0492e242852a133c5bfbf.svg";
export { ForwardRef as ReactComponent };